export default __webpack_public_path__ + "static/media/referimenti.b0cc685e.svg";